import React from 'react';
import { useParams } from 'react-router-dom';
import { useScyStrategies, useScyVault } from '@sc1/common/hooks';
import { VaultInfo } from './VaultInfo';

export const ScyVaultInfo = (): JSX.Element => {
  const { vaultAddress } = useParams();

  const vault = useScyVault(vaultAddress);
  const { strategies } = useScyStrategies(vault);

  return <VaultInfo strategies={strategies} />;
};
